import React from 'react';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';

const UiIconButton = ({ children, ...otherProps }) => {
  return (
    <IconButton color='primary' {...otherProps}>
      {children}
    </IconButton>
  );
};

UiIconButton.propTypes = {
  children: PropTypes.element,
};

export default UiIconButton;
